import React from 'react'
import {
  IconActivity,
  IconAddressBook,
  IconAdjustments,
  IconArrowsExchange,
  IconBellBolt,
  IconBook,
  IconBuilding,
  IconBuildingSkyscraper,
  IconBulb,
  IconCertificate,
  IconChartBar,
  IconChartDots,
  IconChartLine,
  IconChartPie,
  IconChecklist,
  IconClipboardCheck,
  IconClipboardList,
  IconClipboardText,
  IconCompass,
  IconDeviceDesktop,
  IconFileExport,
  IconFileMusic,
  IconGauge,
  IconHeadphones,
  IconHistory,
  IconInbox,
  IconKey,
  IconLayoutDashboard,
  IconLifebuoy,
  IconListNumbers,
  IconMessageCircle,
  IconMessageQuestion,
  IconMessages,
  IconNote,
  IconPlaylist,
  IconPlugConnected,
  IconPresentation,
  IconReportAnalytics,
  IconRobot,
  IconRobotFace,
  IconSchool,
  IconSettings,
  IconShieldCheck,
  IconShieldCog,
  IconSitemap,
  IconSparkles,
  IconSpeakerphone,
  IconStack2,
  IconTargetArrow,
  IconTelescope,
  IconThumbUp,
  IconTool,
  IconTrash,
  IconTrendingUp,
  IconTrophy,
  IconUpload,
  IconUser,
  IconUserCog,
  IconUsers,
  IconWand,
} from '@tabler/icons-react'

import { KodiOutlineIcon } from '@/views/Kodi/KodiMarkIcon'

// Sections
export const FAVORITES = 'favorites'
export const CONVERSATIONS = 'conversations'
export const QUALITY = 'quality'
export const COACHING = 'coaching'
export const REPORTING = 'reporting'
export const INSIGHTS = 'insights'
export const KODI = 'kodi'
export const VOICE_AGENTS = 'voice_agents'
export const USAGE = 'usage'
export const CONFIGURATION = 'configuration'
export const IMPORT_EXPORT = 'import_export'
export const ADMINISTRATION = 'administration'
export const BALTO_ACADEMY = 'balto_academy'

export const SIDEBAR_SECTION_STATE = 'sidebarSectionState'
export const SIDEBAR_FAVORITES = 'sidebarFavorites'
export const SIDEBAR_COLLAPSED = 'sidebarCollapsed'

export const sidebarSections = [
  {
    accessor: CONVERSATIONS,
    title: 'Conversations',
    icon: <IconMessages />,
    links: [
      { path: '/explorer', label: 'Explorer', icon: <IconCompass /> },
      { path: '/live-listen', label: 'Live Listen', icon: <IconHeadphones /> },
      { path: '/playlists', label: 'Playlists', icon: <IconPlaylist /> },
    ],
  },
  {
    accessor: COACHING,
    title: 'Coaching',
    icon: <IconTargetArrow />,
    links: [{ path: '/coaching/inbox', label: 'Coaching Inbox', icon: <IconInbox /> }],
  },
  {
    accessor: QUALITY,
    title: 'Quality',
    icon: <IconChecklist />,
    links: [
      { path: '/qa-copilot/inbox', label: 'Quality Inbox', icon: <IconInbox /> },
      { path: '/compliance/inbox', label: 'Compliance Inbox', icon: <IconShieldCheck /> },
      {
        path: '/qa-copilot/dashboard',
        label: 'Dashboard',
        exact: true,
        icon: <IconLayoutDashboard />,
      },
      {
        path: '/qa-copilot/enterprise',
        label: 'Enterprise Dashboard',
        icon: <IconBuildingSkyscraper />,
      },
      {
        path: '/scorecards/dashboard',
        label: 'RTQ Dashboard',
        exact: true,
        icon: <IconLayoutDashboard />,
      },
      { path: '/scorecards/view_scores', label: 'RTQ Scores', icon: <IconListNumbers /> },
      { path: '/qa-copilot/activity', label: 'Activity', icon: <IconActivity /> },
      { path: '/scorecards/activity', label: 'RTQ Activity', icon: <IconActivity /> },
    ],
  },
  {
    accessor: REPORTING,
    title: 'Reporting',
    icon: <IconChartPie />,
    links: [
      // Guidance stays active across the report tabs, but not on the two
      // /reports sections that have their own sidebar links (Agent Usage
      // under Usage, Playbook Export under Import/Export).
      {
        path: '/reports',
        label: 'Guidance Analytics',
        icon: <IconChartBar />,
        isActive: (match, location) =>
          location.pathname.startsWith('/reports') &&
          location.pathname !== '/reports/usage' &&
          location.pathname !== '/reports/csv',
      },
      { path: '/leaderboards', label: 'Leaderboards', icon: <IconTrophy /> },
      { path: '/realtime_coaching/reports', label: 'RTA Analytics', icon: <IconChartLine /> },
      {
        path: '/realtime_coaching/activity-log',
        label: 'RTA Activity Log',
        icon: <IconHistory />,
      },
    ],
  },
  {
    accessor: INSIGHTS,
    title: 'Insights',
    icon: <IconTelescope />,
    links: [
      { path: '/trends', label: 'Trends', icon: <IconTrendingUp /> },
      { path: '/discover', label: 'Discover', icon: <IconBulb /> },
      { path: '/agentic-insights', label: 'Agentic Insights', icon: <IconSparkles /> },
    ],
  },
  {
    accessor: KODI,
    title: 'Kodi',
    icon: <KodiOutlineIcon />,
    links: [
      { path: '/kodi', label: 'Kodi', icon: <KodiOutlineIcon /> },
      { path: '/kodi-reports', label: 'Kodi Reports', icon: <IconChartBar /> },
      { path: '/kodi-usage', label: 'Kodi Usage', icon: <IconMessageCircle /> },
    ],
  },
  {
    accessor: VOICE_AGENTS,
    title: 'AI Agents',
    icon: <IconRobotFace />,
    links: [
      { path: '/voice-agents', label: 'Agent Studio', icon: <IconRobot /> },
      { path: '/campaigns', label: 'Campaigns', icon: <IconSpeakerphone /> },
      { path: '/contact-lists', label: 'Contact Lists', icon: <IconAddressBook /> },
      { path: '/togo/analytics', label: 'AI Agent Analytics', icon: <IconChartDots /> },
    ],
  },
  {
    accessor: USAGE,
    title: 'Usage',
    icon: <IconGauge />,
    links: [
      { path: '/reports/usage', label: 'Agent Usage', icon: <IconUser /> },
      { path: '/supervisor-usage', label: 'Supervisor Usage', icon: <IconUsers /> },
      { path: '/omnichannel-usage', label: 'Omnichannel Usage', icon: <IconDeviceDesktop /> },
      { path: '/feature-feedback', label: 'Feature Feedback', icon: <IconThumbUp /> },
    ],
  },
  {
    accessor: CONFIGURATION,
    title: 'Setup',
    icon: <IconSettings />,
    links: [
      { path: '/playbooks', label: 'Playbooks', icon: <IconBook /> },
      { path: '/playbook_mapping', label: 'Playbook Mapping', icon: <IconSitemap /> },
      { path: '/notetaker', label: 'Notes', icon: <IconNote /> },
      { path: '/ai-answers', label: 'AI Answers', icon: <IconMessageQuestion /> },
      {
        path: '/qa-copilot',
        label: 'Scorecards',
        exact: true,
        icon: <IconClipboardCheck />,
      },
      { path: '/scorecards', label: 'RTQ Scorecards', exact: true, icon: <IconClipboardList /> },
      {
        path: '/coaching/scorecards',
        label: 'Coaching Scorecards',
        exact: true,
        icon: <IconClipboardText />,
      },
      { path: '/realtime_coaching/alerts', label: 'Real-Time Alerts', icon: <IconBellBolt /> },
      { path: '/users', label: 'Users', icon: <IconUserCog /> },
    ],
  },
  {
    accessor: IMPORT_EXPORT,
    title: 'Import/Export',
    icon: <IconArrowsExchange />,
    links: [
      { path: '/upload-interactions', label: 'Upload', icon: <IconUpload /> },
      {
        path: '/audio-ingestion-records',
        label: 'Audio Ingestion Records',
        icon: <IconFileMusic />,
      },
      { path: '/reports/csv', label: 'Playbook Export', icon: <IconFileExport /> },
      { path: '/qa-copilot/exports', label: 'Scorecard Export', icon: <IconFileExport /> },
      { path: '/scorecards/exports', label: 'RTQ Scorecard Export', icon: <IconFileExport /> },
      { path: '/realtime_coaching/exports', label: 'RTA Export', icon: <IconFileExport /> },
      { path: '/exports', label: 'Call Asset Export', icon: <IconFileExport /> },
    ],
  },
  {
    accessor: ADMINISTRATION,
    title: 'Administration',
    icon: <IconShieldCog />,
    links: [
      { path: '/organizations', label: 'Organizations', icon: <IconBuilding /> },
      { path: '/quality/calibration', label: 'Calibration', icon: <IconAdjustments /> },
      { path: '/integrations', label: 'Integrations', icon: <IconPlugConnected /> },
      { path: '/tools', label: 'Tools', icon: <IconTool /> },
      { path: '/support-access', label: 'Balto Support Access', icon: <IconLifebuoy /> },
      { path: '/instant-demo', label: 'Instant Demo', icon: <IconPresentation /> },
      { path: '/bulk-rescore', label: 'Bulk Operations', icon: <IconStack2 /> },
      { path: '/keywords_repository', label: 'Keyword Repository', icon: <IconKey /> },
      { path: '/automation-insights', label: 'Automation Insights', icon: <IconWand /> },
      { path: '/erase_customer_data', label: 'Data Cleanup', icon: <IconTrash /> },
    ],
  },
  {
    accessor: BALTO_ACADEMY,
    title: 'Balto Academy',
    icon: <IconCertificate />,
    links: [
      { path: '/balto-academy', label: 'Courses', exact: true, icon: <IconSchool /> },
      {
        path: '/balto-academy/reporting',
        label: 'Academy Reporting',
        icon: <IconReportAnalytics />,
      },
    ],
  },
]
